import { CategoryMJsEnv } from "../category_m_js_env";

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  //メーカー・ブランド
  R3_COMMON.setPageBrand(pageOption.categoryName);
  R3_COMMON.addPlacementType(`brand_page.${pageOption.placementNameNormalLower}`);
  R3_COMMON.addPlacementType(`brand_page.${pageOption.placementNameNormalUpper}`);
  R3_COMMON.addPlacementType(`brand_page.${pageOption.placementNameLeftSide}`);

  pageOption.itemIdList.forEach((itemId: string) => R3_COMMON.addItemId(itemId));
}

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setAddToCartPageRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  var R3_CATEGORY = new r3_category();
  R3_COMMON.addPlacementType('add_to_cart_page.' + pageOption.placementNameMyCatalogModal);

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);

  pageOption.itemIdList.forEach((itemId: string) => R3_COMMON.addItemId(itemId));
};

export const setRrRequestParamsSp = (R3_COMMON: r3_common, pageOption: any) => {
  var R3_CATEGORY = new r3_category();
  R3_COMMON.addPlacementType('category_page.' + pageOption.placementNameM1Sp);

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);

  pageOption.itemIdList.forEach((itemId: string) => R3_COMMON.addItemId(itemId));
}

export const createRrRequestParam = (model: CategoryMJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      //メーカー・ブランド
      placementNameNormalLower: model.rrAreaProfileNormalLower.placementName,
      placementNameNormalUpper: model.rrAreaProfileNormalUpper.placementName,
      placementNameLeftSide: model.rrAreaProfileLeftSide.placementName,
      categoryCode: model.categoryCode,
      categoryName: model.categoryName,
      itemIdList: model.itemIdList
    },
  };
}

export const createRrRequestParamSp = (model: CategoryMJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParamsSp,
    pageOption: {
      placementNameM1Sp: model.rrAreaProfileM1Sp.placementName,
      categoryCode: model.categoryCode,
      categoryName: model.categoryName,
      itemIdList: model.itemIdList
    },
  };
}
